var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.733,
    height: 15.641,
    viewBox: "0 0 14.733 15.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32343",
    "data-name": "Group 32343",
    transform: "translate(540.475 -483.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M-530.144,488.622s-.147-2.8-1.551-4.054a1.863,1.863,0,0,0-2.782.115,1.864,1.864,0,0,0,.2,2.778C-532.871,488.712-530.144,488.622-530.144,488.622Z",
    transform: "translate(-2.964)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M-522.962,488.622s.353-2.8,1.756-4.054a1.864,1.864,0,0,1,2.783.115,1.864,1.864,0,0,1-.2,2.778C-520.029,488.712-522.962,488.622-522.962,488.622Z",
    transform: "translate(-10.146)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M-538.084,504.9v6.1h12.207v-6.1",
    transform: "translate(-1.127 -12.466)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M-531.582,499.267h5.341v-3.815h-13.733v3.815h5.341",
    transform: "translate(0 -6.83)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_565",
    "data-name": "Line 565",
    y2: 9.918,
    transform: "translate(-531.582 488.622)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_566",
    "data-name": "Line 566",
    y1: 9.918,
    transform: "translate(-534.634 488.622)",
    fill: "none",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventGift);
export default __webpack_public_path__ + "static/media/event-gift.f346ef03e9ed4ee33e30af8e4ba91a89.svg";
export { ForwardRef as ReactComponent };